export default "__VITE_ASSET__C4F7lsaS__"